import { createSlice } from '@reduxjs/toolkit';
import { IStateProgress } from '../../../share/types';
import { IFloorType, IFootprintHistory } from '../../../share/types/ark1.0/floorType';
import { IDuplicates } from '../../../share/types/ark1.0/types';
import { loadProjectAction } from './actions';

export interface IFootprintSlice extends IStateProgress {
  floorTypes: IFloorType[];
  currentType: number;
  previousSteps: IFootprintHistory | undefined;
  errors: [];
  duplicates: IDuplicates;
}

const initialState: IFootprintSlice = {
  floorTypes: [],
  currentType: -1,
  previousSteps: undefined,
  isLoading: false,
  isError: false,
  errors: [],
  duplicates: {
    id_1: '',
    id_2: '',
  },
};

const floorSlice = createSlice({
  name: 'floor',
  initialState,
  reducers: {
    resetFloorState(slice : IFootprintSlice) {
      return ({
        ...slice,
        floorTypes: [],
        currentType: -1,
        previousSteps: undefined,
        isLoading: false,
        isError: false,
        errors: [],
        duplicates: {
          id_1: '',
          id_2: '',
        },
      });
    },
  },
  extraReducers: {
    [loadProjectAction as any]: (slice: IFootprintSlice, { payload }: any) => ({
      ...slice,
      floorTypes: payload,
      currentType: 0,
    }),
  } as any,
});

export const {
  resetFloorState,
} = floorSlice.actions;
export const floorReducer = floorSlice.reducer;
